import React, {useRef, useEffect} from 'react'
import './contact.css';
import Map from './Map'
import firebase from './../../config/fbConfig.js'
import {Helmet} from "react-helmet";
import ChangeLang from '../changeLang/changeLang';


function Contact() {
    const emailAddress = useRef()
    const name = useRef()
    const subject = useRef()
    const message = useRef()

    useEffect(() => {
        setTimeout(() => {
            document.getElementById('contact').firstChild.firstChild.classList.add('fadeIn');
        })
        
        return () => {
            document.getElementById('contact').firstChild.firstChild.classList.remove('fadeIn');
        }
    }, [])

    let sendMessage = (e, email, name, subject, message) => {
        
        if (email==="" || name === "" || subject === "" || message === "") {
            if (window.location.href.includes('/en')) {
                alert("You must fill all the fields before sending.")
            } else {
                alert("עליך למלא את כל הפרטים לפני שליחה.")
            }
            return;
        }

        firebase.analytics().logEvent('message_contact_sent', {
            email,
            name,
            subject,
            message
        })
        if (window.location.href.includes('/en')) {
            prompt("This isn't a real restaurant. \nFeel free to contact the creator of this website - Itay Shiff - in his email", 'etay2468@gmail.com');
        } else {
            prompt("זאת לא מסעדה אמיתית. \nהרגיש חופשי ליצור קשר עם מנהל ויוצר האתר - איתי שיף - באיימיל שלו:", 'etay2468@gmail.com');
        }
        
        document.getElementById('leftSide').reset();
    }

// If it is an English page, so render it in english
if (window.location.href.includes('/en')) {
	return (
        <>
        <ChangeLang/>

        <div id="contact">
             <Helmet>
                <html lang="en" />
				<title>Contact Us | Itay's Restaurant</title>
				<meta 
				name="description" 
				content="Feel free to contact us at any time. Itay's Restaurant (© Itay Shiff), or in email: etay2468@gmail.com." />
			</Helmet>

           
            
            <div className="backgroundAbout">
                <div className="contentAbout">
                    <div className="titlePage">Contact Us</div>
                    <div id="contactWrapper">
                        <form id="leftSide" onSubmit={(e) => e.preventDefault()}>
                            <label htmlFor="emailAddress">Email Address <span>*</span></label>
                            <input type="email" id="emailAddress" ref={emailAddress} required/>
                            <label htmlFor="emailAddress">Full Name <span>*</span></label>
                            <input type="text" id="name" ref={name} required/>
                            <label htmlFor="emailAddress">Subject <span>*</span></label>
                            <input type="text" id="subject" ref={subject} required/>
                            <label htmlFor="emailAddress">Message <span>*</span></label>
                            <textarea type="text" id="query" ref={message} required/>
                            <button onClick={(e) => sendMessage(window.event, emailAddress.current.value, name.current.value, subject.current.value, message.current.value)}>SEND MESSAGE</button>
                        </form>
                        <div id="rightSide">
                            <div>
                                <Map/>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        </div>

        </>
    )
}
    // Else render it in hebrew
    return (
        <>
        <ChangeLang/>
         <div id="contact" className='hebrew'>
             <Helmet>
				<title>צור קשר | המסעדה של איתי</title>
				<meta 
				name="description" 
                content="הרגישו חופשי ליצור איתנו קשר בכל עת ! (המסעדה של איתי שיף) או באימייל: etay2468@gmail.com" />
			</Helmet>
           
            
            <div className="backgroundAbout">
                <div className="contentAbout">
                    <div className="titlePage">צור קשר</div>
                    <div id="contactWrapper">
                        <form id="leftSide" onSubmit={(e) => e.preventDefault()}>
                            <label htmlFor="emailAddress">כתובת אימייל <span>*</span></label>
                            <input type="email" id="emailAddress" ref={emailAddress} required/>
                            <label htmlFor="emailAddress">שם מלא <span>*</span></label>
                            <input type="text" id="name" ref={name} required/>
                            <label htmlFor="emailAddress">נושא <span>*</span></label>
                            <input type="text" id="subject" ref={subject} required/>
                            <label htmlFor="emailAddress">הודעה <span>*</span></label>
                            <textarea type="text" id="query" ref={message} required/>
                            <button onClick={(e) => sendMessage(window.event, emailAddress.current.value, name.current.value, subject.current.value, message.current.value)}>SEND MESSAGE</button>
                        </form>
                        <div id="rightSide">
                            <div>
                                <Map/>
                            </div>
                        </div>
                    </div>
                </div>  
            </div>
        </div>
        </>
    )
}

export default Contact
